var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { staticClass: "mb-n1" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "6" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Search",
                  placeholder: "Search...",
                  outlined: "",
                  clearable: "",
                  dense: "",
                  "hide-details": "",
                  disabled: _vm.isLoading,
                  "prepend-inner-icon": "mdi-magnify"
                },
                model: {
                  value: _vm.searchTerm,
                  callback: function($$v) {
                    _vm.searchTerm = $$v
                  },
                  expression: "searchTerm"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "3" } },
            [
              _c("v-select", {
                attrs: {
                  items: _vm.sections,
                  disabled: _vm.isLoading,
                  label: "Sections",
                  outlined: "",
                  dense: "",
                  clearable: "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.selectedSection,
                  callback: function($$v) {
                    _vm.selectedSection = $$v
                  },
                  expression: "selectedSection"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "3" } },
            [
              !_vm.hideStatus
                ? _c("v-select", {
                    attrs: {
                      items: _vm.statuses,
                      disabled: _vm.isLoading,
                      label: "Statuses",
                      outlined: "",
                      dense: "",
                      clearable: "",
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.selectedStatus,
                      callback: function($$v) {
                        _vm.selectedStatus = $$v
                      },
                      expression: "selectedStatus"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.filteredMonsters,
          "items-per-page": 15,
          dense: "",
          search: _vm.searchTerm,
          "footer-props": {
            showFirstLastPage: true,
            itemsPerPageOptions: [-1, 10, 15, 20, 25],
            firstIcon: "mdi-arrow-collapse-left",
            lastIcon: "mdi-arrow-collapse-right",
            prevIcon: "mdi-minus",
            nextIcon: "mdi-plus"
          }
        },
        scopedSlots: _vm._u(
          [
            {
              key: `item.name`,
              fn: function({ item }) {
                return [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: { name: "readMonster", params: { id: item.keyId } },
                        title: item.name
                      }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(item.name ? item.name : `(NONE)`) + " "
                      )
                    ]
                  )
                ]
              }
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }